var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryTransferOrderIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27422_73407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80859 6.50584C6.02332 6.79291 6.29727 7.03043 6.61187 7.20231C6.92647 7.37419 7.27435 7.4764 7.63192 7.50201C7.98949 7.52762 8.34839 7.47603 8.68427 7.35073C9.02015 7.22544 9.32515 7.02938 9.57859 6.77584L11.0786 5.27584C11.534 4.80434 11.786 4.17283 11.7803 3.51734C11.7746 2.86185 11.5117 2.23482 11.0481 1.7713C10.5846 1.30778 9.95759 1.04485 9.3021 1.03916C8.6466 1.03346 8.0151 1.28545 7.54359 1.74084L6.68359 2.59584",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80772 5.49474C7.59299 5.20768 7.31904 4.97015 7.00444 4.79827C6.68985 4.62639 6.34196 4.52418 5.98439 4.49857C5.62682 4.47297 5.26792 4.52456 4.93204 4.64985C4.59616 4.77514 4.29116 4.97121 4.03772 5.22474L2.53772 6.72474C2.08232 7.19625 1.83034 7.82775 1.83603 8.48324C1.84173 9.13874 2.10465 9.76577 2.56817 10.2293C3.03169 10.6928 3.65872 10.9557 4.31421 10.9614C4.96971 10.9671 5.60121 10.7151 6.07272 10.2597L6.92772 9.40474",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27422_73407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.808594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryTransferOrderIcon);
export default __webpack_public_path__ + "static/media/SummaryTransferOrderIcon.b417770308a36a1c2efb45c6c9ee01db.svg";
export { ForwardRef as ReactComponent };